var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcaselittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.54 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #5b5757;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.54,0c-1.31,0-2.52.42-3.5,1.13l.23.32.23-.32c-.98-.71-2.19-1.13-3.5-1.13C2.69,0,0,2.69,0,6s2.69,6,6,6c1.31,0,2.52-.42,3.5-1.13l-.23-.32-.23.32c.98.71,2.19,1.13,3.5,1.13,3.31,0,6-2.69,6-6S15.85,0,12.54,0v.79c2.87,0,5.2,2.33,5.21,5.2,0,2.88-2.33,5.2-5.21,5.21-1.14,0-2.18-.37-3.04-.98l-.23-.17-.23.17c-.86.62-1.9.98-3.04.98-2.87,0-5.2-2.33-5.21-5.21,0-2.87,2.33-5.2,5.21-5.2,1.14,0,2.18.37,3.04.98l.23.17.23-.17c.86-.62,1.9-.98,3.04-.98v-.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.02,6.09h-.25c0,1.11-.45,2.11-1.17,2.83-.72.72-1.72,1.17-2.83,1.17s-2.1-.45-2.83-1.17c-.72-.72-1.17-1.72-1.17-2.83s.45-2.11,1.17-2.83c.73-.72,1.72-1.17,2.83-1.17s2.11.45,2.83,1.17c.73.73,1.17,1.72,1.17,2.83h.5c0-2.49-2.02-4.5-4.5-4.5s-4.5,2.02-4.5,4.5,2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5h-.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaselittle);
export default __webpack_public_path__ + "static/media/showcaselittle.74faab4018b2e8bc5150693f9d70b17f.svg";
export { ForwardRef as ReactComponent };